export default {"src":"/_next/static/media/tick.d9b093a8.svg","height":6,"width":7,"blurWidth":0,"blurHeight":0};